import { createSaga } from './saga-helpers';

import * as Api from '../api/auth-api';

const watchGetAuthDetails = createSaga({
    type: 'AUTH_DETAILS_FETCH',
    fn: Api.fetchAuthDetails,
    successPayload: details => ({ details })
});

const watchSetAuthDetails = createSaga({
    type: 'AUTH_DETAILS_SET',
    fn: Api.setAuthDetails,
    args: action => [action.payload.masterToken, action.payload.teamToken, action.payload.teamUrl]
});

const watchSetMasterToken = createSaga({
    type: 'MASTER_TOKEN_SET',
    fn: Api.setMasterToken,
    args: action => [action.payload.masterToken]
});

const watchSetTeamToken = createSaga({
    type: 'TEAM_TOKEN_SET',
    fn: Api.setTeamToken,
    args: action => [action.payload.teamUrl, action.payload.teamToken]
});

const watchRemoveTeamToken = createSaga({
    type: 'TEAM_TOKEN_REMOVE',
    fn: Api.removeTeamToken,
    args: action => [action.payload.teamUrl]
});

const watchSetTeamUrl = createSaga({
    type: 'TEAM_URL_SET',
    fn: Api.setTeamUrl,
    args: action => [action.payload.teamUrl]
});

const authSagas = [watchGetAuthDetails, watchSetAuthDetails, watchSetMasterToken, watchSetTeamToken, watchRemoveTeamToken, watchSetTeamUrl];

export default authSagas;
